function initializeSlick($section) {
  const $slider = $section.find('.megamenu-slider-first-1');
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }
  if ($section.is(':visible')) {
    $slider.slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: `<div class="left-arrow-menu">       
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.5">
        <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white"/>
        <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#C7B5E3"/>
        <path d="M24.2463 28.8781C24.3153 28.9425 24.3707 29.0201 24.4092 29.1063C24.4476 29.1926 24.4683 29.2857 24.4699 29.3801C24.4716 29.4745 24.4542 29.5683 24.4189 29.6559C24.3835 29.7434 24.3309 29.8229 24.2641 29.8897C24.1973 29.9565 24.1178 30.0091 24.0303 30.0445C23.9427 30.0798 23.8489 30.0972 23.7545 30.0955C23.6601 30.0939 23.567 30.0732 23.4808 30.0348C23.3945 29.9963 23.3169 29.9409 23.2525 29.8719L13.8775 20.4969C13.7458 20.365 13.6719 20.1863 13.6719 20C13.6719 19.8136 13.7458 19.6349 13.8775 19.5031L23.2525 10.1281C23.3858 10.0039 23.5621 9.93629 23.7442 9.9395C23.9264 9.94272 24.1002 10.0165 24.229 10.1453C24.3579 10.2742 24.4316 10.448 24.4349 10.6301C24.4381 10.8123 24.3705 10.9886 24.2463 11.1219L15.3693 20L24.2463 28.8781Z" fill="#775ACB"/>
        </g></svg> </div>`,
       nextArrow: `<div class="right-arrow-menu">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.5">
        <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white"/>
        <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#C7B5E3"/>
        <path d="M26.12 20.4969L16.745 29.8719C16.6117 29.9961 16.4354 30.0637 16.2532 30.0605C16.0711 30.0572 15.8973 29.9834 15.7684 29.8546C15.6396 29.7258 15.5658 29.552 15.5626 29.3698C15.5594 29.1877 15.627 29.0114 15.7512 28.8781L24.6282 20L15.7512 11.1219C15.627 10.9886 15.5594 10.8123 15.5626 10.6301C15.5658 10.448 15.6396 10.2742 15.7684 10.1453C15.8973 10.0165 16.0711 9.94272 16.2532 9.9395C16.4354 9.93629 16.6117 10.0039 16.745 10.1281L26.12 19.5031C26.2516 19.6349 26.3256 19.8136 26.3256 20C26.3256 20.1863 26.2516 20.365 26.12 20.4969Z" fill="#775ACB"/>
        </g></svg></div>`,
    });
  } else {
    setTimeout(() => {
      if ($section.is(':visible')) {
        initializeSlick($section);
      }
    }, 100);
  }
}

$('.childlink-title').on('mouseenter', function () {
  const targetSelector = $(this).data('target');
  const $targetSection = $(targetSelector);

  if (!$targetSection.length) return;
  $('.childlink-title').removeClass('activeListItem');
  $('.main-megamenu-item-inner').removeClass('activeItem');
  // Activate current
  $(this).addClass('activeListItem');
  $targetSection.addClass('activeItem');

  // Init or refresh Slick for new section
  if ($targetSection.find('.megamenu-slider-first-1').hasClass('slick-initialized')) {
    $targetSection.find('.megamenu-slider-first-1').slick('refresh');
  } else {
    initializeSlick($targetSection);
  }
});
// Re-init Slick if menu is toggled open
$('details.mega-menu').on('toggle', function () {
  if (this.open) {
    const $active = $('.main-megamenu-item-inner.activeItem');
    if ($active.length) {
      if ($active.find('.megamenu-slider-first').hasClass('slick-initialized')) {
        $active.find('.megamenu-slider-first').slick('refresh');
      } else {
        initializeSlick($active);
      }
    }
  }
});
function handleMenuHoverAndClick(sectionId) {
        var $section = $(sectionId);
        $section.find('.childlink-title').on('mouseenter click', function() {
            var target = $(this).data('target');
            $section.find('.childlink-title').removeClass('activeListItem');
            $(this).addClass('activeListItem');
            $section.find('.main-megamenu-item-inner').removeClass('activeItem');
            $(target).addClass('activeItem');
        });
    }
    for (var i = 1; i <= 5; i++) {
        var sectionId = '#MegaMenu-Content-' + i;
        handleMenuHoverAndClick(sectionId);
    }
    $('.menu-drawer__menu li details summary').click(function(){
    var details = $(this).parent('details');
    $('.menu-drawer__menu li details').not(details).removeAttr('open');
  });
//   document.querySelectorAll('.mega-menu').forEach(menu => {
//   menu.addEventListener('toggle', () => {
//     const body = document.body;
//     if (document.querySelector('.mega-menu[open]')) {
//       body.style.overflow = 'hidden';
//     } else {
//       body.style.overflow = '';
//     }
//   });
// });